<template>
    <div>
        <!-- View Mode -->
        <AuditSummaryView
            v-if="panelType === 'viewSummary'"
            :audit="audit"
            @open-modal="$emit('open-modal')"
            @edit-audit="$emit('edit-audit')"
            @view-audit="$emit('view-audit')"
            @perform-audit="$emit('perform-audit')"
            @continue-audit="$emit('continue-audit')"
        />

        <!-- Edit / Upload Mode -->
        <AuditSummaryForm
            v-else-if="['uploadSummary', 'editSummary'].includes(panelType)"
            ref="form"
            :audit="audit"
            :new-entry="panelType == 'uploadSummary'"
            @areas="$emit('areas')"
            @open-modal="$emit('open-modal', audit?.id)"
            @submit="
                (preparedData, newEntry, sendNotification) =>
                    $emit('submit', preparedData, newEntry, sendNotification)
            "
        />
    </div>
</template>

<script>
import AuditSummaryView from './AuditSummaryView.vue';
import AuditSummaryForm from './AuditSummaryForm.vue';

export default {
    name: 'AuditSummaryPanel',
    props: {
        panelType: String,
        audit: Object,
    },
    components: {
        AuditSummaryView,
        AuditSummaryForm,
    },
    emits: [
        'open-modal',
        'edit-audit',
        'view-audit',
        'perform-audit',
        'continue-audit',
        'submit',
        'areas',
    ],
    methods: {
        submitForm() {
            if (['uploadSummary', 'editSummary'].includes(this.panelType)) {
                this.$refs.form?.submitForm();
            }
        },
    },
};
</script>
